<header>
  <h1>
    10-sec Executive Board
  </h1>
  <div class="tool-bar">
    <lib-breadcrumbs
      data-test="tags"
      [buttons]="tags()"
    />

    <lib-info-modal>
      <lib-modal-content/>
    </lib-info-modal>

    <lib-feature-display-selector/>

    <lib-select-button
      [options]="availablePeriods()"
      [model]="focusPeriod()"
      (modelChange)="updateFocusPeriod($event)"
    />
  </div>
</header>

<main>
  <lib-feature-kpi [tileViewPage]="PagePath.HotSpotsView" [reportPath]="PagePath.ReportView"/>
</main>

@if (isAIAssistantEnabled()) {
  <lib-feature-insights [includeTotal]="true" [isExecutive]="true"/>
}
